import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { Article, Category } from "../support.types";

export type SupportArticlesData = {
  articles: Article[];
  categories: Category[];
};

/**
 * Fetches support articles and categories.
 * React Query is the source of truth - no sync to Context/Zustand.
 *
 * @example
 * ```typescript
 * const { data, isLoading } = useFetchSupportArticles();
 *
 * if (isLoading) return <Loader />;
 *
 * return (
 *   <SupportList
 *     articles={data?.articles ?? []}
 *     categories={data?.categories ?? []}
 *   />
 * );
 * ```
 */
export function useFetchSupportArticles() {
  return useQuery({
    queryKey: ["support-articles"],
    queryFn: () => apiRequest("/articles/", "GET", null, false),
    select: (data): SupportArticlesData => ({
      articles: data.articles ?? [],
      categories: data.categories ?? [],
    }),
  });
}

export default useFetchSupportArticles;
